module.exports = __webpack_public_path__ + "img/concept-ai-agents.00c4286a.svg";